import priceDimension from './price_dimension.vue';

export default priceDimension;
